import ApiFetcher3 from './ApiFetcher3';

class UserExperimentSegmentsApi {
  static get() {
    return ApiFetcher3.get('user/me/experiment/');
  }
}

export default UserExperimentSegmentsApi;
